var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuildingVerified(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35237",
    "data-name": "Group 35237",
    transform: "translate(-757.7 -295)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9815",
    "data-name": "Rectangle 9815",
    width: 40,
    height: 40,
    transform: "translate(757.7 295)",
    fill: "red",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35293",
    "data-name": "Group 35293",
    transform: "translate(760.7 300.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72291",
    "data-name": "Path 72291",
    d: "M1,19.264H35",
    transform: "translate(-1 10.085)",
    fill: "none",
    stroke: "#388968",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72292",
    "data-name": "Path 72292",
    d: "M18.072,22.111V15.218",
    transform: "translate(10.951 7.253)",
    fill: "none",
    stroke: "#388968",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72293",
    "data-name": "Path 72293",
    d: "M19.491,9.164a3.39,3.39,0,0,0-3.4,3.4v3.508a3.4,3.4,0,1,0,6.8,0V12.564A3.39,3.39,0,0,0,19.491,9.164Z",
    transform: "translate(9.564 3.015)",
    fill: "none",
    stroke: "#388968",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72294",
    "data-name": "Path 72294",
    d: "M2,31.348V6.667C2,3.561,3.545,2,6.621,2h9.628c3.075,0,4.605,1.561,4.605,4.667V31.348",
    transform: "translate(-0.3 -2)",
    fill: "none",
    stroke: "#388968",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72295",
    "data-name": "Path 72295",
    d: "M5.364,6.764h7.65",
    transform: "translate(2.055 1.335)",
    fill: "none",
    stroke: "#388968",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72296",
    "data-name": "Path 72296",
    d: "M5.364,10.173h7.65",
    transform: "translate(2.055 3.721)",
    fill: "none",
    stroke: "#388968",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72297",
    "data-name": "Path 72297",
    d: "M7.591,21.65v-5.8",
    transform: "translate(3.614 7.698)",
    fill: "none",
    stroke: "#388968",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingVerified);
export default __webpack_public_path__ + "static/media/building-verified.87f1b26ed155023d40254390291909f9.svg";
export { ForwardRef as ReactComponent };